import { t } from './../dictionary'

const convert = (_: string, group1: string, group2: string) => {
  const currencyGroup1 = `${group1} reais `
  const currencyGroup2 = group2.length > 1 ? `e ${group2} centavos` : ''
  return `${currencyGroup1}${currencyGroup2}`
}

export const phraseToCurrencyValues = (value: string) => {
  const regex = /\s?R\u0024(\s?\d*),?\s?(\d*)/gi
  return value.replace(regex, convert)
}

export const acceptedInvitationsToFormattedText = (value: number) => {
  if (value == 0) return ''
  return `${value} ${value > 1 ? t.invitationsAccepted : t.invitationAccepted}`
}

const convertToCelsius = (_: string, group1: string, group2: string) => {
  return `de ${group2} graus ${group1 ? 'negativos' : ''}`
}

export const convertCelsiusToAriaLabel = (value: string) => {
  const regex = /(\u002D?)(\d*)\u00BAC/gi
  return value.replace(regex, convertToCelsius)
}
